import { BasicRequest } from "./basicRequest";

export class UndeleteFilterDefinitionRequest extends BasicRequest{
    public filterDefinitionId! : number;
}